import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Loader2 } from 'lucide-react';

const ProtectedRoute: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const location = useLocation();

    useEffect(() => {
        // Fetch active session
        supabase.auth.getSession().then(({ data: { session } }) => {
            setIsAuthenticated(!!session);
        });

        // Listen for authentication changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            setIsAuthenticated(!!session);
        });

        return () => subscription.unsubscribe();
    }, []);

    // While checking session, show a premium dark loader
    if (isAuthenticated === null) {
        return (
            <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center text-white gap-4 font-sans">
                <div className="relative flex items-center justify-center">
                    {/* Glowing background circle */}
                    <div className="absolute w-24 h-24 bg-[#00d4ff]/10 rounded-full filter blur-[15px] animate-pulse" />
                    <Loader2 className="w-10 h-10 text-[#00d4ff] animate-spin relative" />
                </div>
                <div className="text-center space-y-1">
                    <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#00d4ff]">Fisura Expeditions</p>
                    <p className="text-[9px] font-bold uppercase tracking-widest text-gray-500">Verificando sesión segura...</p>
                </div>
            </div>
        );
    }

    // Redirect to /login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // Render children if authenticated
    return <Outlet />;
};

export default ProtectedRoute;
